module.exports = __webpack_public_path__ + "img/price-quote7.3ec3e336.png";